exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.images_menu[data-v-0055e912]{\n  letter-spacing: unset;\n  margin-left: 4px;\n  margin-right: 4px;\n  color: #16232e !important;\n  font-size: small !important;\n}\n", ""]);

// exports
